import React, { Children } from 'react';
import { arrayOf, element, oneOfType, string } from 'prop-types';
import clsx from 'clsx';

import SearchInput from '../containers/Global/SearchInput';

import classes from './ActionBar.module.css';

const noop = () => {};

const ActionBar = ({
    endAdornments,
    children,
    isDisabled,
    customClass,
    onSearch,
    startAdornments,
    searchPlaceholder,
    searchValue
}) => {
    const isSearchHidden = !onSearch || onSearch === noop;

    return (
        <aside className={classes.root}>
            <aside
                className={clsx(classes.adornments, classes.startAdornments)}
            >
                {startAdornments}
                <SearchInput
                    className={customClass ? clsx(classes.searchInput, customClass) : classes.searchInput}
                    hidden={isSearchHidden}
                    disabled={isDisabled}
                    placeholder={searchPlaceholder}
                    search={onSearch}
                    value={searchValue}
                />
            </aside>
            <ul className={classes.actionItems}>
                {Children.map(children, (child, key) => (
                    <li key={key}>{child}</li>
                ))}
            </ul>
            <aside
                className={clsx(classes.adornments, classes.endAdornments)}
            >
                {endAdornments}
            </aside>
        </aside>
    );
};

ActionBar.defaultProps = {
    endAdornments:     null,
    onSearch:          noop,
    searchPlaceholder: 'Search',
    searchValue:       '',
    startAdornments:   null
};

ActionBar.propTypes = {
    children: oneOfType([
        element,
        arrayOf(element)
    ]),
    endAdornments:     element,
    searchPlaceholder: string,
    searchValue:       string,
    startAdornments:   element
};

export default ActionBar;
